module.exports = __webpack_public_path__ + "static/media/DSC03295_lakefield_bts_Small.b808ae8f.jpg";